import type { HeaderProps } from '~/utils/header'
import defu from 'defu'
import { boolean, fallback, object, optional, parse } from 'valibot'

const metaSchema = object({
  // Whether the header should be narrow (suitable for e.g. nettbutikk routes)
  narrow: fallback(optional(boolean()), false),

  // where header should be scrollable (i.e. not fixed)
  scrollable: fallback(optional(boolean()), false),
})

/**
 * Merge metadata from route meta and props, with the route-specific metadata taking precedence.
 */
export function useHeaderMeta(props: MaybeRefOrGetter<HeaderProps>) {
  const route = useRoute()

  const context = getNavigationContext()

  return computed(() => {
    const meta = parse(metaSchema, defu(route?.meta?.header ?? {}, toValue(props)))
    return {
      context,
      narrow: meta.narrow || context === 'marketing',
      scrollable: meta.scrollable || context === 'marketing',
    }
  })
}
